import React from 'react';
import {Outlet} from 'react-router-dom';
import HeaderBar from '../elements/HeaderBar';
import LoginModal from '../modals/LoginModal';
import { Server } from 'src/server/server';
import MessageModal from '../modals/MessageModal';

interface SitePageState {
  login: boolean;
  message: string;
}

class SitePage extends React.Component<{}, SitePageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      login: false,
      message: ''
    }
  }

  onLogin() {
    this.setState({login: true})
  }

  onLogout() {
    this.setState({message: 'Logging out...'});

    setTimeout(async () => {
      await Server.signOut();
      this.setState({message: ''});
    }, 1000);
  }

  render() {
    return (
      <div id="id-app-page">
        <HeaderBar onLogin={()=>this.onLogin()} onLogout={()=>this.onLogout()}/>
        <Outlet />
        <MessageModal message={this.state.message} />
        <LoginModal mode={this.state.login ? 'login' : ''} onClose={()=>this.setState({login: false})}/>
      </div>
    )
  }
}

export default SitePage;
